<h2>Select Product Group(s)</h2>

<div *ngFor="let group of groupList">
  <mat-checkbox [(ngModel)]="group.selected">{{ group.name }}</mat-checkbox>
</div>

<div style="margin-top: 1rem;">
  <button mat-raised-button color="primary" (click)="onSubmit()">Assign</button>
  <button mat-button (click)="onCancel()">Cancel</button>
</div>
